import React from 'react';
import HomePage from '../pages/HomePage';

const Home = () => {
  return <HomePage />;
};

export default Home; 